import { Markup } from "interweave";
import React, { useContext } from "react";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import Ronaldo from "../../.././../../Assets/Images/ronaldo.jpg";
// import "./MarketPlaceSearch.css";
import "./AuctionSearch.css";

const AuctionSearch = (props) => {

  const { imageCdnUrl } = useContext(serverInfo);



  return (
    <div>
      <div className="searchUserFirst">
        <h6 className="mx-3 py-2 text-light">Auction</h6>
        <div className="underLineBlackSearch"></div>

        <div className="my-2 py-3">
          <div className="row">
            {props.searchSuggAuction?.map((auction) => (
              <div className="col-md-6">
                <div className=" row tabBG TabMar">
                  <div className="col-md-6">
                    <div className="">
                      <OwlCarousel
                        items={1}
                        loop
                        autoplay
                        autoplayTimeout={3000}
                        margin={0}
                        dots={false}
                      >
                        <img
                          src={imageCdnUrl + auction?.product_image}
                          alt=""
                          className="img-fluid AuctionsImgSearch "
                        />
                      </OwlCarousel>
                    </div>
                  </div>

                  <div className="col-md-6 containerAuc px-3">
                    <div className="w-100">
                      <h4>{auction?.title.substring(0, 15)}</h4>
                      <p className="text-light ">
                        {/* Lorem ipsum dolor sit amet consectetur  */}

                        <Markup
                          content={auction?.details.substring(0, 40)}
                        ></Markup>
                      </p>

                      <div className="text-light ">
                        <span className="DollarPrice fw-bold">
                          {" "}
                          $ {auction?.base_price}
                        </span>
                        &nbsp;
                        <small className="text-light border border-warning bestPrice">
                          {" "}
                          Best Price{" "}
                        </small>
                      </div>
                      <div className="d-flex mt-2 JerseyAucProAuto w-100">
                        <img
                          src={imageCdnUrl + auction.star.image}
                          className="AuctionProImg img-fluid"
                          alt="star-profile"
                        />
                        <span className="mx-2 mt-1 SpanAu">
                          <small className="proTextSm text-light fw-bold">
                            Superstar
                          </small>
                          <div className="proTextAc">
                            {auction.star?.first_name}
                            {auction.star?.last_name}
                          </div>
                        </span>
                      </div>

                      <Link to={`/starprofile/${auction.star.id}`}>
                        <button className="btn bg-warning mt-2  fw-bold w-100 JerseyAucBuy">
                          {" "}
                          Participate
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuctionSearch;
